import React, { createContext, useState, useMemo, ReactNode, useContext } from 'react';
import { IMessageType } from '../../../interfaces/common';

interface Messages {
  messages: IMessageType[];
  addMessage: (message: IMessageType) => void;
  clearMessages: () => void;
}

// Default value for context to avoid `undefined` errors
const MessagesContext = createContext<Messages>(null);

const MessagesContextProvider = ({ children }: { children: ReactNode }) => {


  const [messages, setMessages] = useState<IMessageType[]>([]);


  const photoMessages = useMemo(
    () => ({
      messages,
      addMessage: (message: IMessageType) => setMessages((prev) => [...prev, message]),
      clearMessages: () => setMessages([]),
    }),
    [messages]
  );

  return <MessagesContext.Provider value={photoMessages}>{children}</MessagesContext.Provider>;
};

// Custom Hook for safer context usage
const useMessages = () => {
  const context = useContext(MessagesContext);
  if (!context) {
    throw new Error('useMessages must be used within a MessagesContextProvider');
  }
  return context;
};

export { MessagesContext, MessagesContextProvider, useMessages };
